"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadlineLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HeadlineLayout = ({
  banner,
  debug,
  modulePosition,
  className
}) => {
  const {
    modules,
    layout
  } = banner;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  if (!modules?.[0]?.content) {
    return (0, _utils.getModulesContentError)({
      debug,
      layout,
      modulePosition
    });
  }
  const {
    title
  } = modules[0].content;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.Headline),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Headline, {
      textAlign: "center",
      variant: "h4",
      component: "h2",
      maxLines: isMobile ? 3 : 2,
      children: title
    })
  });
};
exports.HeadlineLayout = HeadlineLayout;
